import {ProjectSolvencyReport} from "../../models/reporting/ProjectSolvencyReport";
import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestStateProp,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    FETCH_PROJECT_SOLVENCY_REPORT,
    FETCH_PROJECT_SOLVENCY_REPORT_BY_PROJECT,
    FETCH_PROJECT_SOLVENCY_REPORT_BY_PROJECT_ERROR,
    FETCH_PROJECT_SOLVENCY_REPORT_BY_PROJECT_SUCCESS,
    FETCH_PROJECT_SOLVENCY_REPORT_ERROR,
    FETCH_PROJECT_SOLVENCY_REPORT_SUCCESS,
    ProjectSolvencyReportActionTypes
} from "../../actions/reporting/ProjectSolvencyReportActions";


export interface ProjectSolvencyReportState extends RequestStateProp {
    reports: Nullable< ProjectSolvencyReport[] >
    detailedReport: Nullable<ProjectSolvencyReport>
    projectionPeriodInMonths: number
    totalEntries: number
}


const initialState: ProjectSolvencyReportState = {
    reports: null,
    detailedReport: null,
    projectionPeriodInMonths: 12,
    totalEntries: 0,
    request: getInitialRequestState()
};

export function ProjectSolvencyReportReducer(
    state: ProjectSolvencyReportState = initialState,
    actions: ProjectSolvencyReportActionTypes
) {

    switch( actions.type ) {

        case FETCH_PROJECT_SOLVENCY_REPORT:
            return {
                ...state,
                projectionPeriodInMonths: actions.projectionPeriodInMonths,
                request: startFetchingRequestState()
            };
        case FETCH_PROJECT_SOLVENCY_REPORT_SUCCESS:
            return {
                ...state,
                reports: actions.reports.entries,
                totalEntries: actions.reports.totalEntries,
                request: successFetchingRequestState()
            };
        case FETCH_PROJECT_SOLVENCY_REPORT_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( actions.error )
            };
        case FETCH_PROJECT_SOLVENCY_REPORT_BY_PROJECT:
            return {
                ...state,
                request: startFetchingRequestState()
            };
        case FETCH_PROJECT_SOLVENCY_REPORT_BY_PROJECT_SUCCESS:
            return {
                ...state,
                detailedReport: actions.report,
                request: successFetchingRequestState()
            };
        case FETCH_PROJECT_SOLVENCY_REPORT_BY_PROJECT_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( actions.error )
            };
        default:
            return state;

    }


}